import { Modal } from "../modal";
import Button from "../../form/button";
import { useTranslations } from "use-intl";
import Text from "../../typography/text";
import { DeleteOutlined } from "@ant-design/icons";
import { ReactNode } from "react";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  onDelete?: () => void;
  title?: ReactNode;
  description?: ReactNode;
};

export function DeleteVerificationModal({
  onClose,
  onDelete,
  open,
  title,
  description,
}: ModalProps) {
  const t = useTranslations("DeleteModal");

  return (
    <Modal
      open={open}
      onOk={onClose}
      title={title ?? t("Title")}
      onCancel={onClose}
      footer={
        <>
          <Button onClick={onClose} neutral>
            {t("Cancel")}
          </Button>
          <Button
            icon={<DeleteOutlined />}
            danger
            type="primary"
            data-testid="delete-confirm-button"
            onClick={() => {
              onDelete?.();
              onClose();
            }}
          >
            {t("Delete")}
          </Button>
        </>
      }
    >
      <Text>{description ?? t("Verification")}</Text>
    </Modal>
  );
}
